export { idlFactory } from './idlFactory';
export * from '../../../declarations/backend/backend.did';
export const BACKEND_CANISTER_ID = import.meta.env.VITE_BACKEND_CANISTER_ID;
